import { render } from "./BlockApplicationsPreviewModal.vue?vue&type=template&id=50946074"
import script from "./BlockApplicationsPreviewModal.vue?vue&type=script&lang=js"
export * from "./BlockApplicationsPreviewModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__